import React from 'react';
import {Stack} from '@mui/material';
import {
  designSystemToken,
  Icon,
  Label,
  Banner,
} from '@lightricks/react-design-system';

interface SingleAlertDisplayProps {
  errorTitle: string;
  errorDescription: string;
  onClose?: () => void;
}

function SingleAlertDisplay({
  errorTitle,
  errorDescription,
  onClose,
}: SingleAlertDisplayProps) {
  return (
    <Banner
      isOpen
      autoHide={false}
      title={errorTitle}
      onActionClick={onClose}
      mode="light"
      icon={
        <Icon
          name="Actions-Patch-Accept-Line"
          size="medium"
          appearance="brand"
        />
      }
      sx={{
        top: '0',
        width: '544px',
      }}
    >
      {errorDescription}
    </Banner>
  );
}

export default SingleAlertDisplay;
